import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { SEO } from '@/components/SEO';

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="text-2xl sm:text-3xl font-semibold text-primary mb-3">{title}</h2>
    <div className="prose prose-slate max-w-none text-slate-600 leading-relaxed">
      {children}
    </div>
  </section>
);

export default function AboutPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO
        title={t('seo.about.title')}
        description={t('seo.about.description')}
        canonical="https://ridalo.co/about"
      />
      <Header />
      <main className="flex-1 py-14 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="about-page">
          <h1 className="text-4xl sm:text-5xl font-bold text-primary tracking-tight">
            {t('about.pageTitle')}
          </h1>
          <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
            {t('about.intro1')}
          </p>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            {t('about.intro2')}
          </p>

          <Section title={t('about.missionTitle')}>
            <p>{t('about.missionP1')}</p>
            <p>{t('about.missionP2')}</p>
          </Section>

          <Section title={t('about.travelersTitle')}>
            <p>{t('about.travelersP1')}</p>
            <p>{t('about.travelersP2')}</p>
          </Section>

          <Section title={t('about.providersTitle')}>
            <p>{t('about.providersP1')}</p>
            <p>{t('about.providersP2')}</p>
          </Section>

          <Section title={t('about.evolvingTitle')}>
            <p>{t('about.evolvingP1')}</p>
          </Section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
